import { Box, Button, Typography } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import React from "react";

export function OutreachContent() {
  const { t } = useTranslation(
    "ui-components-website\\Outreach\\OutreachContent"
  );

  return (
    <Box
      sx={{
        color: "primary.700",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      <Typography
        variant="h6"
        sx={{ fontSize: 22, my: "1rem", fontWeight: "bold" }}
      >
        {t`Teachers can Earn $50 with OUTreach`}
      </Typography>
      <Typography variant="body2" sx={{ fontSize: 18, my: "1rem" }}>
        {t`Share your OUTreach link to refer new parents to Outschool and earn \
rewards when their learner attends their first class.`}
      </Typography>
      <Typography
        variant="body2"
        sx={{ fontSize: 18, my: "1rem" }}
      >{t`Some Limitations apply.`}</Typography>
      <Button
        variant="link"
        onClick={() =>
          window.open("https://info.outschool.com/outreach-program", "_blank")
        }
        sx={{ textAlign: "left", fontSize: 13, my: "1rem" }}
      >
        {t`OUTreach Terms Of Use`}
      </Button>
    </Box>
  );
}
